import * as React from 'react';

export default function EnterpriseDesktopLoggedOutMainNav() {
  return <div>EnterpriseDesktopLoggedOutMainNav</div>;
}
